import React, { useState } from "react";
import logo from "../assets/logo/Logo.svg";
import google from "../assets/logo/Google.svg";
import facebook from "../assets/logo/Facebook.svg";
import apple from "../assets/logo/apple.png";
import Carousel from "./carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom"; // Import for navigation
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export default function VerifyCodeSignup() {
    const navigate = useNavigate(); // Initialize navigation
   

  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const requestData = {
      email: email,  // Email entered by the user
      otp: code,     // Verification code entered by the user
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/auth/verify-credential`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        console.log("Verification Successful:", data);
        alert("Verification Successful! Please log in.");
  
        // Redirect to login page
        navigate("/login");
      } else {
        console.error("Verification Failed:", data);
        alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  ;

  // Carousel login
  let slides = [
    loginbanner,
    loginbannertwo,
    loginbannerthree,
    loginbannerfour
  ];
  let slidessm = [
    loginbannersm,
    loginbannersm,
    loginbannersm,
    loginbannersm,
  ];

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3 ">
            <Carousel slides={slides} />
            {/* <!-- Overlay Image --> */}
            <img src={bannerlayout} alt="Overlay" class="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>
        {/* Right side login form */}
        <div className=" w-full lg:w-1/2 login-content flex flex-col">
          <div className="lg:hidden">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slidessm} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="login-form">
            {/* Language selector */}
            <div className="flex justify-end">

              <Menu as="div" className="language-btn relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        >
                        </button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>
            {/* Main Content */}
            <div className="reset-pass flex flex-col items-center justify-center px-6">
              {/* Logo */}
              <div className=" logo">
                <img
                  src={logo}
                  alt="Pipaan Logo"
                  width={150}
                  height={50}
                />
              </div>

              {/* Back to Login */}
              <div className="w-full max-w-md">
                <Link to="/login" className="back-to-login text-[#313131] text-sm flex items-center mb-4">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
                  </svg>
                  Back to login
                </Link>

                {/* Verification Form */}
                <div className="w-full">
                  <h1 className="login-title text-2xl font-semibold text-left mb-2">Verify Code</h1>
                  <p className="text-left text-[#313131] text-sm mb-8">
                    An authentication code has been sent to your email.
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-4 mb-10">

                  <div className="w-full relative mb-5 reset-pass-content">
                      {/* <label className="text-sm font-medium block mb-1">Enter Verification Code</label> */}
                      <input
                        type="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>

                    <div className="w-full relative mb-5 reset-pass-content">
                      {/* <label className="text-sm font-medium block mb-1">Enter Verification Code</label> */}
                      <input
                        type="text"
                        placeholder="Enter Verification Code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>


                
                    <p className="text-sm text-[#313131] text-center">
                      Didn’t receive a code?{" "}
                      <button className="text-[#006838] font-medium hover:underline">Resend</button>
                    </p>

                    <button
                      type="submit"
                      className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-[#FFFFFF] py-3 rounded-xl font-medium "
                    >
                      Verify
                    </button>
                  </form>

                  {/* Social Login */}
                  <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t-2 border-gray-200"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="bg-white px-2 text-gray-500">Login With</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-10 mx-auto w-fit">
                    <button className="w-full rounded-lg p-2">
                      <img
                        src={google}
                        alt="Facebook"
                        className=" mx-auto" />
                    </button>
                    <button className="w-full rounded-lg p-2">
                      <img
                        src={facebook}
                        alt="Facebook"
                        className=" mx-auto"
                      />
                    </button>
                    {/* <button className="w-full rounded-lg p-2">
                      <img
                        src={apple}
                        alt="Apple"
                        className=" mx-auto"
                      />
                    </button> */}

                  </div>
                  {/* Signup Link */}
                  <p className="text-center text-sm text-[#313957] mt-4">
                    Don't you have an account?{" "}
                    <Link to="/signup" className="text-[#006838] font-semibold hover:underline">
                      Create New Account
                    </Link>
                  </p>
                  {/* Footer */}
                  <div className="lg:hidden">

                    <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                      © 2025 Pipaan. All Rights Reserved
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
